import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getProducts (callback, param) {
    if (param !== undefined) {
      HTTP.get('products' + param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getProductsUnderCategory (callback, param) {
    if (param !== undefined) {
      HTTP.get('products/under/category' + param + '&under_cat=1').then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getProductsByKeyword (callback, keyword) {
    if (keyword !== undefined) {
      HTTP.get('products/keyword?keyword=' + keyword).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  deleteProduct (callback, param) {
    HTTP.delete('products', {data: {id: param}}).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getProductById (productId, language, callback) {
    HTTP.get('products/' + productId + '?language=' + language).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: id is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateProduct (productId, body, callback) {
    HTTP.put('products', body).then(response => {
      if (response.status === 201) {
        callback(response)
      }
    }).catch(e => {
      if (e.response.status === 400) {
        callback(e.response)
      } else if (e.response.status === 500) {
        console.log('Error: Server error')
      } else if (e.response.status === 401) {
        HttpFunctions.response401()
      } else if (e.response.status === 403) {
        console.log('Error: pdo error message')
      }

      console.log(e)
    })
  },
  addProduct (body, callback) {
    HTTP.post('products', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getProductImages (productId, callback) {
    HTTP.get('products/image/' + productId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateImagesOrder (body, callback) {
    HTTP.put('products/image', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: images is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteProductImage (body, callback) {
    HTTP.delete('products/image', {
      data: body
    }).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: image_id is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getRelatedProducts (productId, callback) {
    HTTP.get('products/relate/' + productId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  addRelatedProduct (body, callback) {
    HTTP.post('products/relate', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteRelatedProduct (body, callback) {
    HTTP.delete('products/relate', {
      data: body
    }).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: image_id is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getApiBaseUrl () {
    return HttpFunctions.getApiBaseUrl()
  },
  getApiHeaders () {
    return HttpFunctions.getApiHeaders()
  },
  checkProductStaticUrl (body, callback) {
    if (body !== undefined) {
      HTTP.get('products/static_url/' + body).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  checkProductSku (body, callback) {
    if (body !== undefined) {
      HTTP.get('products/sku/' + encodeURIComponent(body)).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  checkProductSkuList (body) {
    return new Promise((resolve, reject) => {
      if (body !== undefined) {
        HTTP.post('products/sku/checking_list', body).then(response => {
          if (response.status === 200) {
            resolve(response)
          }
        }).catch(e => {
          if (e.response.status === 401) {
            HttpFunctions.response401()
          } else if (e.response.status === 400) {
            reject(new Error('Error: required data is missing'))
          } else if (e.response.status === 403) {
            reject(new Error('Error: pdo error message'))
          }
        })
      } else {
        reject(new Error('Error: Undefined body'))
      }
    })
  },
  uploadProductImage (body, callback) {
    HTTP.post('products/image', body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      callback(e.response)
    })
  },
  getVelaeasySections (callback, productId) {
    if (productId !== undefined) {
      HTTP.get('products/velaeasy_sections/' + productId).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getCountAllProducts (callback, token) {
    if (token) {
      HTTP.defaults.headers.common['Authorization'] = token
    }
    HTTP.get('products/countall').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateProductImage (body, callback) {
    let imageId = body.get('image_id')
    HTTP.post('products/image/' + imageId, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e.response)
      callback(e.response)
    })
  },
  getProductLabels (callback, token) {
    if (token) {
      HTTP.defaults.headers.common['Authorization'] = token
    }
    HTTP.get('products/label').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: required data is missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/products/index.js